<div class="text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Confirm Deployment {{action}}</h4>
    <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onCancel()" title="Close"></i>
  </div>
  <div class="modal-body">
    <p><strong>Are you sure you want to {{action}} <span class="synchpc-primary">"{{ depName }}"</span> deployment?</strong></p>
    <p *ngIf="action == 'Power Off'">
      This is a risky operation.
      <span class="text-danger">This operation can not be undone.</span>
    </p>
    <p>Please type name of deployment to confirm.</p>
    <input type="text"
           spellcheck="false"
           class="confirmInput"
           [(ngModel)]="inpVal" />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Cancel</button>
    <button type="button" class="btn btn-danger" [disabled]="inpVal != depName" (click)="onSubmit()">{{action}}</button>
  </div>
</div>
